import mapFunction from './mapResources';

export default mapFunction('trainings', {
    isFetching: false,
    items: []
});
